import styled from 'styled-components';

export const TagsField = styled.p`
  display: flex;
  gap: 5px;
  margin: 0 0 10px;
  font-style: normal;
  font-size: 10px;
  font-weight: 500;
  line-height: 10px;
  text-align: left;
  color: var(--color-link);
  flex-wrap: wrap;

  * {
    white-space: unset !important;
    overflow: visible !important;
    text-overflow: unset !important;
  }

  &:empty {
    display: none;
  }
`;
